import { Routes } from '@angular/router';
import { CustomerAdminRequiredGuard } from '@core/guards/customer-admin-required.guard';
import { FTPAdminRequiredGuard } from '@core/guards/ftp-admin-required.guard';
import { UserRequiredGuard } from '@core/guards/user-required.guard';
import { SetupRequiredComponent } from './admin/components/setup-required.component';
import { UnauthorizedComponent } from './admin/components/unauthorized.component';
import { PortalComponent } from './portal.component';
import { UserPreferencesComponent } from './preferences/components/user-preferences/user-preferences.component';

export const portalRoutes: Routes = [
  {
    path: '',
    component: PortalComponent,
    children: [
      {
        path: 'organizations',
        loadChildren: () => import('./organizations/organizations.module').then(m => m.OrganizationsModule),
        canActivate: [UserRequiredGuard, CustomerAdminRequiredGuard],
        runGuardsAndResolvers: 'always'
      },
      {
        path: 'users',
        loadChildren: () => import('./users/users.module').then(m => m.UsersModule),
        canActivate: [UserRequiredGuard, CustomerAdminRequiredGuard],
        runGuardsAndResolvers: 'always'
      },
      {
        path: 'results',
        loadChildren: () => import('./lab-results/lab-results.module').then(m => m.LabResultsModule),
        canActivate: [UserRequiredGuard],
        runGuardsAndResolvers: 'always'
      },
      {
        path: 'ftp',
        loadChildren: () => import('./ftp/ftp.module').then(m => m.FTPModule),
        canActivate: [UserRequiredGuard, FTPAdminRequiredGuard],
        runGuardsAndResolvers: 'always'
      },
      {
        path: 'preferences/user-preferences',
        component: UserPreferencesComponent,
        canActivate: [UserRequiredGuard]
      },
      {
        path: 'unauthorized',
        component: UnauthorizedComponent
      },
      {
        path: 'analytic-reports',
        loadChildren: () => import('./analytic-reports/analytic-reports.module').then(m => m.AnalyticReportsModule),
        runGuardsAndResolvers: 'always',
        canActivate: [UserRequiredGuard]
      },
      {
        path: 'setup-required',
        component: SetupRequiredComponent
      },
      {
        path: 'help',
        loadChildren: () => import('./help/help.module').then(m => m.HelpModule),
        canActivate: [UserRequiredGuard],
        runGuardsAndResolvers: 'always'
      },
    ],
    canActivate: [UserRequiredGuard],
    runGuardsAndResolvers: 'always'
  }
];
